<template>
  <b-modal
    size="lg"
    v-model="commentsModal"
    footer-class="removed"
    :title="modalTitle"
    centered
    header-class="bg-warning text-white"
  >
    <b-card-text class="p-1">
      <div v-html="feedbackContent"></div>
    </b-card-text>
  </b-modal>
</template>

<script>
import { BModal, BCardText } from "bootstrap-vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
import store from "@/store";
import feedbackStore from "./store";

export default {
  components: { BModal, BCardText },
  methods: {
    // ...mapActions("FeedbackModule", ["fetchFeedback"]),
    ...mapMutations("FeedbackModule", ["setModalVisibility"]),
  },
  computed: {
    ...mapGetters("FeedbackModule", [
      "isModalVisible",
      "feedbackContent",
      "loading",
      "modalTitle",
    ]),
    commentsModal: {
      get() {
        return this.isModalVisible;
      },
      set(val) {
        this.setModalVisibility(val);
      },
    },
  },
  beforeCreate() {
    if (!store.hasModule("FeedbackModule")) {
      store.registerModule("FeedbackModule", feedbackStore);
    }
  },
  destroyed() {
    store.unregisterModule("FeedbackModule");
  },
};
</script>

<style>
.text-white > .modal-title {
  color: #fff !important;
}
</style>
